import BillboardAdn from '../../../../../pages/vip/features/billboard-adn/billboard-adn-bottom';

export default BillboardAdn;
